/**
 * Demo 示例 接口操作类
 *
 * @module DemoAPI
 * @since 1.0.0
 * @version 1.0.0
 */

import http from './http'

/**
 * @class OrderAPI
 */
export default class OrderAPI {
  /**
   * 小票详情
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getPrintOrderDetail(id) {
    return http.get({
      url: `/order/order/printOrderDetail/${id}`,
    })
  }
  static getOrderPlanPrintOrderDetail(id) {
    return http.get({
      url: `/order/orderPlan/printDetail/${id}`,
    })
  }
  static getOrderChannel(id) {
    return http.get({
      url: `/order/channel/receive/${id}`,
    })
  }
  static getOrderQueryOrderDetail(id) {
    return http.get({
      url: `/order/head/invoice/read/queryOrderDetail/${id}`,
    })
  }
  // 图片
  static getOrderDetailPicList(data) {
    // console.log('请求参数', options)
    return http.post({
      url: `/order/order/getOrderDetailPicList`,
      data,
    })
  }
  /**
   * 小票详情
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getPrintOrderImage(options) {
    return http.get({
      url: `/goods/v1/goods/${options.vars.id}/pics`,
    })
  }

  /**
   * 发货详情
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static printDeliverGoodsDetail(id) {
    return http.get({
      url: `/order/order/printDeliverGoodsDetail/${id}`,
    })
  }

  /**
   * 充值单小票详情
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getChargeOrderDetail(id) {
    return http.get({
      url: `/balance/v1/balanceRecord/${id}`,
    })
  }

  /**
   * 18期销售单
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static orderpurchase(id, options) {
    return http.get({
      url: `/order/purchase/h5/${id}`,
      params: {
        ...options,
      },
    })
  }
  /**
   * 采购订货单详情
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static buyOrder(orderID, options) {
    return http.get({
      url: `${process.BUILD.API_HOST}/api/order/v1/purchase/plan/h5/${orderID}`,
      params: {
        ...options,
      },
    })
  }
  /**
   * 小票详情
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getPrintTemplate(options = {}) {
    return http.get({
      ...options,
      url: `/base/v1/shareBlueToothTemplates`,
    })
  }
  static getPrintTemplate2(options = {}) {
    return http.post({
      ...options,
      url: `/base/v2/blueToothTemplates/nologin/getByStore`,
    })
  }

  /**
   * 小票分享检查绑定状态
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static checkWechat(options = {}) {
    return http.get({
      ...options,
      url: `/thirdparty/fwh/customer/wechatInfo`,
      params: {
        ...options.params,
      },
    })
  }

  /**
   * 小票分享微信绑定
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static bindWechat(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/bindWechat`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 小票分享微信解绑
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static unBindWechat(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/unbindWechat`,
      data: {
        ...options.data,
      },
    })
  }

  // 查询广告
  static getSaleBillAds(options = {}) {
    return http.post({
      ...options,
      url: `/base/v1/tenantSetting/saleBillAds`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 商品销量统计
   *
   * @since 1.0.0
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static queryCusGoodsSaleStatistic(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/wxa/customer/queryCusGoodsSaleStatistic`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 动态生成短链
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   * /bpi 是为了开发环境和测试使用
   */
  static getWechatRrl(options = {}) {
    options.params = options?.params || {}
    options.params['envVersion'] = options.params?.envVersion || process.env.VUE_APP_MODE
    return http.get({
      ...options,
      // url: `/bpi/thirdparty/api/v1/wx/mini/url`, // 开发环境 和 测试环境 线上测试
      // url: `/thirdparty/api/v1/wx/mini/url`, // 开发环境 和 测试环境 为了让地址可以访问外网 本地测试
      url: `/thirdparty/api/v1/wx/mini/url`, // 预发环境 和 线上环境
    })
  }

  /**
   * 查询openid的绑定状态
   * docs: http://192.168.4.60:3000/project/53/interface/api/115819
   */
  static queryBindStatus(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/queryBindStatus`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 查询openid的绑定状态
   * docs: http://192.168.4.60:3000/project/53/interface/api/115826
   */
  static getQueryBindStatus(options = {}) {
    return http.get({
      ...options,
      url: `/thirdparty/fwh/customer/queryBindStatus`,
    })
  }

  /**
   * 查找开过单的店铺集合
   * docs: http://192.168.4.60:3000/project/53/interface/api/115833
   */
  static getOrderStores(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/getOrderStores`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 公众号h5客户注册
   * docs: http://192.168.4.60:3000/project/53/interface/api/114804
   */
  static customerMemberRegister(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/memberRegister`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 店铺下的订单信息
   * docs: http://192.168.4.60:3000/project/53/interface/api/114797
   */
  static getStoreOrderList(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/getStoreOrderList`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * h5 最近卡券包 + 即将失效券 type 1 最近获得 2 即将失效 3 历史
   * docs: http://192.168.4.60:3000/project/314/interface/api/115868
   */
  static getReceiveCouponPage(options = {}) {
    return http.post({
      ...options,
      url: `/activity/v1/receive/search/recently/receiveCouponPage/h5`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 获取权限验证配置 微信sdk接入
   * docs: http://192.168.4.60:3000/project/53/interface/api/115980
   */
  static getWechatJsSign(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/wechat/fwh/jsSign`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 可用门店
   * docs: http://192.168.4.60:3000/project/314/interface/api/115875
   */
  static getStoreSearch(options = {}) {
    return http.post({
      ...options,
      url: `/activity/v1/receive/storeSearch/h5`,
      data: {
        ...options.data,
      },
    })
  }

  /**
   * 发放优惠券/领取优惠券 H5页面
   * docs: http://192.168.4.60:3000/project/305/interface/api/39866
   */
  static getCouponGeneration(options = {}) {
    return http.get({
      ...options,
      url: `/activity/v1/receive/receive/generation?couponId=${options.params.couponId}&customerId=${options.params.customerId}`,
      params: {
        ...options.data,
      },
    })
  }

  /**
   * 优惠券领取信息 + 优惠券详情信息
   * docs: http://192.168.4.60:3000/project/305/interface/api/39839
   */
  static checkWechatcoupon(options = {}) {
    return http.get({
      ...options,
      url: `/activity/v1/receive/coupon/receive/detail?couponId=${options.params.couponId}&customerId=${options.params.customerId}`,
      params: {
        ...options.params,
      },
    })
  }

  static getRequired(options = {}) {
    return http.get({
      ...options,
      url: `/member/v1/customers/getRequired/byTenantId`,
    })
  }

  static printChannelRefundOrderDetail(id) {
    return http.get({
      url: `/order/channel/refund/read/printChannelRefundOrderDetail/${id}`,
    })
  }
  static invoiceprintChannelRefundOrderDetail(id) {
    return http.get({
      url: `/order/head/invoice/read/printOrderDetail/${id}`,
    })
  }
  static jsMainSwept(options = {}) {
    return http.post({
      ...options,
      url: `/order/prePay/v1/jsMainSwept`,
    })
  }
  static editWxUserInfo(options = {}) {
    return http.post({
      ...options,
      url: `/thirdparty/fwh/customer/editWxUserInfo`,
    })
  }
}
